document.addEventListener('DOMContentLoaded', function() {
  const prevBtn = document.querySelector('.js-related-collection-slide__button-previous');
  const nextBtn = document.querySelector('.js-related-collection-slide__button-next');
  const carousel = document.querySelector('.js-related-collection-slide__slide');
  const scrollThreshold = 1;

  const updateButtonVisibility = function() {
    if (!carousel || !prevBtn || !nextBtn) return;
    const carouselWidth = carousel.clientWidth;
    const carouselScrollWidth = carousel.scrollWidth;
    if (carouselWidth >= carouselScrollWidth) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }
    const atStart = carousel.scrollLeft <= 0;
    const atEnd = carousel.scrollLeft + carouselWidth + scrollThreshold >= carouselScrollWidth;
    prevBtn.style.display = atStart ? 'none' : 'flex';
    nextBtn.style.display = atEnd ? 'none' : 'flex';
  };

  const getScrollStep = function() {
    const cards = document.querySelectorAll('.js-related-collection-slide__slide-card');
    const refCard = cards.length > 1 ? cards[1] : cards[0];
    return refCard ? refCard.offsetWidth : 0;
  };

  const buttonEvents = function() {
    if (!carousel || !prevBtn || !nextBtn) return;
    prevBtn.addEventListener('click', function() {
      carousel.scrollTo({ left: carousel.scrollLeft - getScrollStep(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      carousel.scrollTo({ left: carousel.scrollLeft + getScrollStep(), behavior: 'smooth' });
    });
  };

  if (carousel) {
    carousel.addEventListener('scroll', updateButtonVisibility);
    updateButtonVisibility();
  }
  buttonEvents();

  window.addEventListener('resize', function() {
    updateButtonVisibility();
  });
});
